import ToolBar from '@/components/ToolBar';
import { Sheet, SheetContent } from '@/components/ui/sheet';
import { X } from 'lucide-react';
import CourtCreate from './CourtCreate';

export const CreateCourtModal = ({
  onClose,
  setUpdatedCourt,
}: {
  onClose: () => void;
  setUpdatedCourt: () => void;
}) => {
  return (
    <Sheet modal={true} open={true}>
      <SheetContent
        hideCloseButton={true}
        className="md:w-[40vw] w-[80vw] h-fit min-w-[35vw] flex flex-col scrollbar-hide focus:outline-none rounded-lg gap-0"
        side={'center'}
      >
        <div className="flex flex-col justify-between px-8">
          <div className="flex flex-row justify-between sticky top-0 pt-8 bg-white z-10">
            <ToolBar title={'Add New Court'} />
            <div className="h-fit border-[1px] rounded-sm focus-within:border-focuscolor p-1 ">
              <X
                color="#676767"
                className="h-[20px] w-[20px] cursor-pointer focus:outline-none"
                onClick={onClose}
                tabIndex={0}
              />
            </div>
          </div>

          <CourtCreate
            displayType="MODAL"
            onSave={() => {
              onClose();
              setUpdatedCourt();
            }}
            onClose={onClose}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
};
